export function hasValues(obj: unknown): boolean {
  if (obj == null) return false;
  if (Array.isArray(obj)) return obj.length > 0;
  if (typeof obj === "object") {
    for (const key of Object.keys(obj as Record<string, unknown>)) {
      const val = (obj as Record<string, unknown>)[key];
      if (val !== undefined && val !== null && val !== "") return true;
    }
    return false;
  }
  return true;
}


